import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'kp-text-field',
  templateUrl: './text-field.component.html',
  styleUrls: ['./text-field.component.scss'],
})
export class TextFieldComponent {
  @Input() isShortText = false;
  @Input() maxCharacters: number;
  @Input() placeholderText: string;
  @Input() textValue = '';

  @Output() textAreaAnswer = new EventEmitter<string>();

  onTyping(text: string): void {
    this.textAreaAnswer.emit(text);
  }
}
